/**
 * FAQCategoryList Component
 */

import { ListItemAnimations } from '../../../utils/animation';
import './faq-category-list.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { VelocityTransitionGroup } from 'velocity-react';

import Heading from '../../atoms/text/Heading';
import { IFAQCategory } from './';
import FAQCategoryButton from './FAQCategoryButton';

interface IOwnProps {
  categories: IFAQCategory[];
  onSelectCategory: (categoryId: string) => void;
}

type FAQCategoryListProps = IOwnProps;

const FAQCategoryListAnimation = ListItemAnimations(128);
const classes = new BEM('faq-category-list');

export default class FAQCategoryList extends React.Component<FAQCategoryListProps, {}> {

  render() {
    return (
      <div {...classes('wrapper')}>
        <Heading is="h4" textColor="bw6" {...classes('title')}>Browse by Topic:</Heading>
        <VelocityTransitionGroup
          component="ul"
          enter={{ animation: FAQCategoryListAnimation.In, stagger: 150 }}
          leave={{ animation: FAQCategoryListAnimation.Out }}
          {...classes()}
        >
        {this.props.categories.map(({ id, title, questions }) => (
          <li key={id} {...classes('item')}>
            <FAQCategoryButton
              id={id}
              title={title}
              totalQuestions={questions.length}
              onSelect={() => this.props.onSelectCategory(id)}
            />
          </li>
        ))}
        </VelocityTransitionGroup>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/FAQ/FAQCategoryList.tsx